import * as React from 'react';
import   { Provider } from 'react-redux';
import  store from './src/state/createStore'
import { StoreProvider } from "./src/context/store-context"
const wrapWithProvider = ({ element }) => (
  
  <Provider store={store}>
  <StoreProvider>{element}</StoreProvider>
  </Provider>
);
export default wrapWithProvider